import Brunerra from '../../Media/Logo Ciputra Cibubur/Brunnera.png'
import Calathea from '../../Media/Logo Ciputra Cibubur/Calathea.png'
import Granbury from '../../Media/Logo Ciputra Cibubur/Granbury.png'


const cbdimages =[
Brunerra,Calathea,Granbury
]

export default cbdimages;